import { Document } from 'app/shared/models/document.model';

export class Agreement {
    id: number;
    relationEntityId: number;
    description: string;
    effectiveDate: Date;
    documents: Document[];
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/agreement.model.ts